import Img from "gatsby-image"
import React from "react"
import { useImageZoom } from "react-medium-image-zoom"

const ImageWithZoom = ({ node, slug }) => {
  const { ref } = useImageZoom({
    overlayBgColorStart: "rgba(0,0,0,0.5)",
    overlayBgColorEnd: "rgba(0,0,0,0.8)",
  })
  return (
    <>
      <div ref={ref}>
        <Img style={{ margin: "0 auto" }} fluid={node.childImageSharp.fluid} />
      </div>
      <div style={{ textAlign: "center" }}>
        {slug !== "oil-paintings" && formatName(node.name)}
      </div>
    </>
  )
}

export default ImageWithZoom

const formatName = name => {
  const splitName = name.slice(2).split("_").join(" ")
  return splitName.charAt(0).toUpperCase() + splitName.slice(1)
}
